import { Box, Button, Divider, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface IVMInformationProps {
    id: string;
}
export const VMInformation: React.FC<IVMInformationProps> = ({
    id
}) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const location = useLocation();
    const navigate = useNavigate();

    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };
    

    return (
    <Box
        display={'flex'}
        flexDirection={smDown? 'column' : 'row'}
        width={'100%'}
        padding={1}
    >
        <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={smDown? 'center' :  'start'}
            width={smDown? '100%' : '50%'}
            padding={0}
        >
            <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registos Legais</Typography>

            <Button variant={isButtonActive(`/information_dam/${id}/entrepreneu_id`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/entrepreneu_id`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Identificação do empreendedor</Typography>
                {/* <Typography variant='body2'>Identificação do empreendedor</Typography> */}
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/features-undertaking`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/features-undertaking`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Caracterização da barragem</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/dam=${id}/organization_chart`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/organization_chart`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Organograma geotecnia </Typography>
            </Button>
        </Box>
        <Divider orientation={smDown? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
        {/* <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={smDown? 'center' :  'start'}
            width={smDown? '100%' : '50%'}
            padding={1}
        >
            <Typography variant='h6' color={theme.palette.primary.main} padding={0} marginLeft={1}>Informações Adicionais</Typography>

            <Button variant={isButtonActive(`/information_dam/${id}/files`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/files`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Arquivos da Barragem</Typography>
            </Button>
            <Button variant={isButtonActive(`/information_dam/${id}/files`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/files`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros fotográficos</Typography>
            </Button>
        </Box> */}
      </Box>
    );
};